<template>
    <div class="form-floating mb-3">
        <input type="number" class="form-control" min="0" :name="id" :id="id" :placeholder="placeholder" :value="getValue()" @change="setValue($event)">
        <label :for="id">{{ title }}</label>
    </div>
</template>

<script>
export default {
    name:    'NumberField',
    props:   ['type', 'id', 'title', 'placeholder'],
    methods: {
        setValue(event) {
            let value = parseInt(event.currentTarget.value);
            value     = (isNaN(value)) ? 0 : value;
            value     = (value < 0) ? 0 : value;

            this.$store.commit('results/setQuestion', {
                id:    this.id,
                value: value
            });

            event.currentTarget.value = value;
        },
        getValue() {
            const question = this.$store.getters['results/getQuestionById'](this.id);

            if(question) {
                return question.value;
            }

            return null;
        }
    }
}
</script>
